import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { AuthActions } from '../common/store/actions/auth.actions';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthConstants, AuthUrls } from './auth.constants';
import { Store } from '@ngrx/store';
import { DealerActions } from '../common/store/actions/dealer.actions';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root',
})
export class KeycloakAuthService {
  constructor(
    private keycloakService: KeycloakService, 
    private store: Store,
    private http: HttpClient) {}

  public init(){
    return this.keycloakService.init({
                                        config: {
                                            url: AuthUrls.AUTH_BASE_URL,
                                            realm: AuthConstants.REALM,
                                            clientId: AuthConstants.CLIENT_ID
                                        },
                                        initOptions: {
                                          pkceMethod: AuthConstants.PKCE_METHOD, 
                                          // must match to the configured value in keycloak
                                          redirectUri: AuthUrls.AUTH_REDIRECT_BASE_URL+'/login',   
                                          // this will solve the error 
                                          checkLoginIframe: false
                                        }}).then(() => {

                                          let loggedIn: boolean = this.keycloakService.isLoggedIn()
                                          let userId: string = ''
                                          if (loggedIn) {
                                            userId = this.keycloakService.getKeycloakInstance().tokenParsed?.sub!;
                                            this.store.dispatch(DealerActions.fetchMyDealerProfileSubmit());
                                            //userId = 'heyy '+userId
                                            //console.log(userId)
                                            //userId = this.keycloakService.getUsername();
                                            
                                            //this.store.dispatch(loginSuccess({ userId }));
                                            //this.sendData()
                                          }

                                          this.store.dispatch(AuthActions.authResult({loggedIn: loggedIn, userId: userId}))
                                        });
  }
  
  sendData() {
    //return this.keycloakService.getUsername();
    console.log('userId heyy')
    this.store.dispatch(AuthActions.authSuccess({}))
  }

  getUserName(): string {
    return this.keycloakService.getUsername();
  }

  logout(location?: any): void {

    this.keycloakService.logout(location);
    AuthActions.logoutSubmit();
    
    //AuthActions.authSuccess({ token: result.data });
    
  }

  login(location?: any): void {

    this.keycloakService.login({redirectUri: location})
    
    //AuthActions.authSuccess({ token: result.data });
    
  }

  isLoggedIn(): boolean{
    return this.keycloakService.isLoggedIn();
  }

  getLoggedUser(): any {
    return this.keycloakService.getKeycloakInstance().idTokenParsed;
  }

  getLoggedUserId(): any {
    return this.keycloakService.getKeycloakInstance().tokenParsed?.sub;
  }

  getLoggedInChar(): string {

    let usr = this.getLoggedUser();
    return (usr.email.charAt(0)).toUpperCase();

    //return (usr.given_name.charAt(0)+usr.family_name.charAt(0)).toUpperCase();
  }

  getToken(): Promise<string> {
    return this.keycloakService.getToken();
  }

  /*

  loginOld({ username, password }: any): Observable<StringData>{ 
    //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;

    let credentials: LoginCredentials = new LoginCredentials (username, password);

    let keycloakLoginOptions: KeycloakLoginOptions = {
      redirectUri: 'http://localhost:4200/'

    }
    this.keycloakService.login(keycloakLoginOptions);

    let url = 'https://liristech.com:8445/auth/realms/master/protocol/openid-connect/token'
    let cred = {

      client_id : 'afcar-we',
      username : username,
      password : password,
      grant_type : "password"
  
    }
    return this.http.post<any>(url, cred, httpOptions );
    
  }

  */

  // signup({ username, password, dealerType }: any): Observable<StringData>{ 
  //   //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;

  //   let credentials: LoginCredentials = new LoginCredentials (username, password);
      
  //   return this.http.post<any>(AppUrl.signup, { username, password, dealerType }, httpOptions );
    
  // }

  // recoverPassword(username: string): Observable<StringData>{ 
  //   //const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&grant_type=password`;
 
  //   return this.http.post<any>(AppUrl.recoverPassword, username, httpOptions );
    
  // }

  // updatePassword(oldPassword: string, newPassword: string): Observable<StringData>{ 
  
  //   return this.http.post<any>(AppUrl.updatePassword, { oldPassword, newPassword }, httpOptions );
    
  // }
}